const SEARCH_HISTORY_KEY = 'forum_search_history';
const MAX_HISTORY = 20;

export const getSearchHistory = () => {
  try {
    const raw = localStorage.getItem(SEARCH_HISTORY_KEY);
    const list = JSON.parse(raw || '[]');
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

export const addSearchHistory = (keyword) => {
  const text = String(keyword || '').trim();
  if (!text) return getSearchHistory();
  const next = [text, ...getSearchHistory().filter((item) => item !== text)].slice(0, MAX_HISTORY);
  localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(next));
  return next;
};

export const clearSearchHistory = () => {
  localStorage.removeItem(SEARCH_HISTORY_KEY);
};
